/**
 * Web-side ability feature flags.
 *
 * Mirrors how the web reads other build-time gates (e.g.
 * `NEXT_PUBLIC_MAINTENANCE_MODE`): a `NEXT_PUBLIC_*` env var, statically
 * inlined by Next at build.
 */

/** Installable app-repo skill bundling (My Kit affordance). Mirror of the
 *  server's SKILL_BUNDLE_ARCHIVE. Read at call time; NEXT_PUBLIC_* needs a rebuild. */
export function isSkillBundleV1Enabled(): boolean {
  return process.env.NEXT_PUBLIC_SKILL_BUNDLE_V1 === "true";
}

/** Abilities are skills and MCPs (agents-first lane A). Web half of the
 *  server's ABILITIES_SLIM_V1: hides the agents chapter and the hooks callout.
 *  Read at call time; NEXT_PUBLIC_* needs a rebuild. */
export function isAbilitiesSlimV1Enabled(): boolean {
  return process.env.NEXT_PUBLIC_ABILITIES_SLIM_V1 === "true";
}
